import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import QtyInput from '../../Shared/QtyInput'
import ConvertQuantity from '../../Shared/ConvertQuantity'
import NumberFormat from 'react-number-format'
import measurementTypes from '../../../_constants/measurementTypes'
import { MdClose } from 'react-icons/md'
import { GoPlus } from 'react-icons/go'
import Fab from '@material-ui/core/Fab'
import { DecimalInput } from 'react-hichestan-numberinput'

const item = { categoryId: '', brandId: '', itemId: '', quantity: 0 }

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <>
    <div className="row display-flex">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <fieldset className="fieldset">
          <legend>اطلاعات کالای تولید شده</legend>
          <table className="table validator-table" style={{ marginBottom: 5 }}>
            <thead>
              <tr>
                <th className="text-center">ردیف</th>
                <th className="text-center">دسته بندی</th>
                <th className="text-center">برند</th>
                <th className="text-center">نام کالا</th>
                <th className="text-center">تعداد ورق پرس شده سالم</th>
                {/* <th className="text-center">ضایعات</th> */}
              </tr>
            </thead>
            <tbody>
              {values.outputs && values.outputs.map((item, index) => (
                <tr key={"p-" + index}>
                  <td>{index + 1}</td>
                  <td>
                    {values.outputs[index].product && values.outputs[index].product.category.name}
                  </td>
                  <td>
                    {values.outputs[index].product && values.outputs[index].product.brand.name}
                  </td>
                  <td>
                    {values.outputs[index].product && values.outputs[index].product.name}
                  </td>
                  <td>
                    <QtyInput
                      disabled={values.outputs[index].product && values.outputs[index].product.conversionUnit}
                      measurementType={values.outputs[index].product && values.outputs[index].product.measurementType}
                      subMeasurementType={values.outputs[index].product && values.outputs[index].product.subMeasurementType}
                      conversionUnit={values.outputs[index].product && values.outputs[index].product.conversionUnit}
                      onChange={(val, subVal) => {

                        if (val !== undefined) {

                          // if (quantity <= values.outputs[index].unitProductQuantity) {
                          setFieldValue(`outputs[${index}][quantity]`, val)
                          // } else {
                          //   setFieldValue(`outputs[${index}][quantity]`, undefined)
                          //   setFieldValue(`outputs[${index}][subWaste]`, undefined)
                          // }

                        } else {
                          setFieldValue(`outputs[${index}][quantity]`, undefined)
                        }

                        setFieldValue(`outputs[${index}][subQuantity]`, subVal)

                      }}
                      value={values.outputs[index].quantity}
                    />
                    <ErrorMessage component={ErrorPopUp} name={`outputs[${index}].quantity`} />
                  </td>
                  {/* <td>
                    {values.outputs[index].product && values.outputs[index].product.conversionUnit ?
                      <QtyInput
                        disabled={values.outputs[index].product && values.outputs[index].product.conversionUnit}
                        measurementType={values.outputs[index].product && values.outputs[index].product.measurementType}
                        subMeasurementType={values.outputs[index].product && values.outputs[index].product.subMeasurementType}
                        conversionUnit={values.outputs[index].product && values.outputs[index].product.conversionUnit}
                        onChange={(val, subVal) => {

                          if (val !== undefined) {

                            // if (waste <= values.outputs[index].unitProductQuantity) {
                            setFieldValue(`outputs[${index}][waste]`, val)
                            // } else {
                            //   setFieldValue(`outputs[${index}][waste]`, undefined)
                            //   setFieldValue(`outputs[${index}][subWaste]`, undefined)
                            // }

                          } else {
                            setFieldValue(`outputs[${index}][waste]`, undefined)
                          }

                          setFieldValue(`outputs[${index}][subWaste]`, subVal)

                        }}
                        value={values.outputs[index].subWaste}
                      />
                      : ''}
                    <ErrorMessage component={ErrorPopUp} name={`outputs[${index}].waste`} />
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </fieldset>
      </div>
    </div>
  </>
);